export class Tutorial {
    constructor() {
        this.currentStep = 0;
        const userData = JSON.parse(localStorage.getItem('userData'));
        const playerGender = userData?.genero || 'M';
        const welcomeImage = playerGender === 'F' ? '/assets/menu/saludowoman.png' : '/assets/menu/saludo.png';
        
        this.steps = [
            {
                title: '¡Bienvenido a\nTAEKWONDO MASTER!',
                content: 'Te enseñaremos cómo funciona el sistema paso a paso.',
                icon: '',
                image: welcomeImage,
                action: null
            },
            {
                title: 'Permisos de Cámara',
                content: 'Necesitamos tu cámara para detectar tus movimientos. NO grabamos video, todo se procesa en tu dispositivo.',
                icon: '📷',
                action: 'camera'
            },
            {
                title: 'Sistema de Energía',
                content: 'Tienes 100 puntos de energía. Entrenamiento cuesta 10, Rotura 5 y Combate IA varía según el oponente. La energía se renueva completamente cada día.',
                icon: '⚡',
                action: null
            },
            {
                title: 'Insignias',
                content: 'Ganá insignias completando logros: vencé 10 combates IA, derrotá al Sabon Nim (4° Dan), al Master (7° Dan), al Gran Master (9° Dan) o completá el Torneo Marcial. Se muestran en tu perfil y en el ranking.',
                icon: '',
                badges: [
                    { src: '/assets/badges/combat-ia-32.png', label: '10 Combates' },
                    { src: '/assets/badges/combat-4dan-32.png', label: '4° Dan' },
                    { src: '/assets/badges/combat-maestro-32.png', label: 'Master' },
                    { src: '/assets/badges/combat-granmaster-32.png', label: 'Gran Master' },
                    { src: '/assets/badges/martial-tournament-32.png', label: 'Torneo' }
                ],
                action: null
            },
            {
                title: 'Importante: Seguridad',
                content: 'Este sistema NO reemplaza el entrenamiento en el dojang con un instructor especializado. Fomenta la práctica en casa de manera divertida y complementaria.',
                icon: '🛡️',
                action: null
            },
            {
                title: 'Aviso',
                content: 'Taekwondo Master es una plataforma independiente y no representa ni está afiliada a ninguna federación, asociación o escuela de Taekwondo. Los logos, imágenes y contenidos publicados pertenecen a sus respectivos usuarios. Este espacio busca unir a los practicantes y no tomar parte en las divisiones existentes dentro del Taekwondo ITF.',
                icon: 'ℹ️',
                action: null
            },
            {
                title: '¡Listo para Empezar!',
                content: 'Ya conoces lo básico. Empieza con el modo Entrenamiento, Combate IA o Rotura. ¡Diviértete y entrena seguro!',
                icon: '🥋',
                action: null,
                disclaimer: true
            }
        ];
    }

    show() {

        const overlay = document.createElement('div');
        overlay.id = 'tutorial-overlay';
        overlay.className = 'tutorial-overlay';
        overlay.innerHTML = `
            <div class="tutorial-modal">
                <div class="tutorial-header">
                    <h2 id="tutorial-title"></h2>
                    <button id="skip-tutorial" class="skip-btn">Saltar Tutorial</button>
                </div>
                <div class="tutorial-body">
                    <div class="tutorial-icon" id="tutorial-icon"></div>
                    <p id="tutorial-content"></p>
                    <div id="tutorial-disclaimer" style="display: none; margin-top: 15px; padding: 10px; background: rgba(255, 107, 53, 0.1); border: 1px solid rgba(255, 107, 53, 0.3); border-radius: 8px; font-size: 0.75rem; color: #ccc; line-height: 1.4;">
                        ⚠️ <strong>TAEKWONDO MASTER</strong> no se responsabiliza de daños que puedan ocurrir durante el uso. Los menores deben ser supervisados por un adulto.
                    </div>
                </div>
                <div class="tutorial-footer">
                    <div class="tutorial-progress">
                        <span id="tutorial-step">1</span> / ${this.steps.length}
                    </div>
                    <button id="tutorial-next" class="btn-primary tutorial-btn">Siguiente →</button>
                </div>
            </div>
        `;

        document.body.appendChild(overlay);
        this.renderStep();
        this.attachEvents();
    }

    renderStep() {
        const step = this.steps[this.currentStep];
        const titleElement = document.getElementById('tutorial-title');
        titleElement.innerHTML = step.title.replace(/\n/g, '<br>');
        
        const iconElement = document.getElementById('tutorial-icon');
        if (step.image) {
            iconElement.innerHTML = `<img src="${step.image}" alt="Welcome" style="max-width: 150px; height: auto;">`;
        } else if (step.badges) {
            iconElement.innerHTML = `<div style="display: flex; gap: 12px; justify-content: center; align-items: center; flex-wrap: wrap;">
                ${step.badges.map(b => `<div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                    <img src="${b.src}" alt="${b.label}" style="width: 48px; height: 48px; object-fit: contain;">
                    <span style="font-size: 0.65rem; color: #aaa;">${b.label}</span>
                </div>`).join('')}
            </div>`;
        } else {
            iconElement.textContent = step.icon;
        }
        
        document.getElementById('tutorial-content').textContent = step.content;
        document.getElementById('tutorial-step').textContent = this.currentStep + 1;

        const disclaimer = document.getElementById('tutorial-disclaimer');
        if (step.disclaimer) {
            disclaimer.style.display = 'block';
        } else {
            disclaimer.style.display = 'none';
        }

        const nextBtn = document.getElementById('tutorial-next');
        if (this.currentStep === this.steps.length - 1) {
            nextBtn.innerHTML = '¡Comenzar! 🚀';
        } else {
            nextBtn.innerHTML = 'Siguiente →';
        }
    }

    attachEvents() {
        document.getElementById('skip-tutorial').onclick = () => this.showSkipConfirmation();
        document.getElementById('tutorial-next').onclick = () => this.next();
    }

    showSkipConfirmation() {
        const confirmModal = document.createElement('div');
        confirmModal.className = 'tutorial-overlay';
        confirmModal.style.zIndex = '10001';
        confirmModal.innerHTML = `
            <div class="tutorial-modal" style="max-width: 400px;">
                <div class="tutorial-header">
                    <h2 style="color: #ff6b35; font-size: 1.5rem;">Saltar Tutorial</h2>
                </div>
                <div class="tutorial-body">
                    <p style="color: #ccc; font-size: 1rem; line-height: 1.6;">
                        ¿Seguro que quieres saltar el tutorial? Podrás verlo después en Configuración.
                    </p>
                </div>
                <div class="tutorial-footer" style="display: flex; gap: 10px; justify-content: flex-end;">
                    <button id="cancel-skip" class="btn-secondary tutorial-btn">Cancelar</button>
                    <button id="confirm-skip" class="btn-primary tutorial-btn">Sí, saltar</button>
                </div>
            </div>
        `;
        
        document.body.appendChild(confirmModal);
        
        document.getElementById('cancel-skip').onclick = () => confirmModal.remove();
        document.getElementById('confirm-skip').onclick = () => {
            confirmModal.remove();
            this.complete();
        };
    }

    next() {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            this.renderStep();
        } else {
            this.complete();
        }
    }

    skip() {
        this.complete();
    }

    complete() {
        document.getElementById('tutorial-overlay')?.remove();
    }
}

export default Tutorial;
